// src/pages/Dashboard.js

import React, { useState, useEffect } from "react";
import { MoonLoader } from "react-spinners"; // Import the loader
import { data, secreteToken } from "../config/data"; // Import routes configuration
import {
  encryptData,
  generateToken,
  decryptData,
  verifyToken,
} from "../utils/crypto"; // Import routes configuration
import { login, logout, isAuthenticated } from "../config/auth";

import * as payment from "../services/razorpay";
import iaaconQrCode from "../images/IAACON.png";
import "./Dashboard.css";

const Dashboard = () => {
  const [loading, setLoading] = useState(true);
  const [isValidToken, setIsValidToken] = useState(false);

  const [decryptedData, setDecryptedData] = useState(null);
  const [authToken, setAuthToken] = useState(null);
  const [paymentModalOpen, setPaymentModalOpen] = useState(false);
  const [transactionId, setTransactionId] = useState("");
  const [submissionState, setSubmissionState] = useState({
    status: "idle",
    message: "",
  });

  // Simulate checking the token validity
  useEffect(() => {
    const query = new URLSearchParams(window.location.search);
    const encryptedData = query.get("info");
    const token = query.get("id");

    // const encryptedData = encryptData(data);
    // const token = generateToken(secreteToken);

    console.log("encryptedData", encryptedData);
    console.log("token", token);

    const checkToken = async () => {
      if (!encryptedData || !token) {
        return;
      }
      setTimeout(async () => {
        const decryptedData = await decryptData(encryptedData);
        const verified = await verifyToken(token);

        if (!decryptedData || !verified) {
          setLoading(false);
          return;
        }

        const valid = await isAuthenticated(verified?.data);
        setDecryptedData(decryptedData);
        setAuthToken(verified?.data);
        setIsValidToken(valid);

        console.log("decryptedData......", decryptedData);

        if (valid && decryptedData?._id !== "6ad847c6d4a0abe524306eee") {
          await payment.makePayment(verified?.data, decryptedData);
        }

        setLoading(false); // Stop loading after checking the token
      }, 2000); // 2 seconds delay
    };

    checkToken();
  }, []);

  const redirectBack = () => {
    window.location.href = `${process.env.REACT_APP_SITE_URL}`;
  };

  const handleTransactionSubmit = async (event) => {
    event.preventDefault();
    setSubmissionState({
      status: "submitting",
      message: "Submitting payment information...",
    });

    try {
      const submitResult = await payment.submitTransactionId(
        authToken,
        decryptedData,
        transactionId.trim(),
      );

      // console.log("submitResult", submitResult);

      if (submitResult?.status.success !== true) {
        throw new Error(
          submitResult?.message ||
            "Unable to submit your payment information. Please try again.",
        );
      }

      setSubmissionState({
        status: "success",
        message:
          "Payment submitted. Conference access will be enabled after verification.",
      });
    } catch (error) {
      setSubmissionState({
        status: "error",
        message:
          error.message ||
          "Unable to submit your payment information. Please try again.",
      });
    }
  };

  if (loading) {
    return (
      <div className="loader-container">
        <h4 style={{ color: "#FFF" }}>Payment is Processing. Please Wait...</h4>
        <MoonLoader color="#36d7b7" size={50} />
      </div>
    );
  }

  if (decryptedData?._id === "6ad847c6d4a0abe524306eee") {
    return (
      <>
        <main className="bank-details-page">
          <section
            className="payment-steps-highlight"
            aria-labelledby="payment-steps-title"
          >
            <h2 id="payment-steps-title">HOW TO COMPLETE YOUR PAYMENT</h2>
            <ol>
              <li>
                <strong>Make the Payment:</strong> Scan the QR code or use the
                bank account details provided.
              </li>
              <li>
                <strong>Enter Transaction ID:</strong> After completing the
                payment, enter the transaction ID below.
              </li>
              <li>
                <strong>Submit:</strong> Click on the Submit button.
              </li>
            </ol>
          </section>
          <section className="payment-qr" aria-labelledby="payment-qr-title">
            <h2 id="payment-qr-title">SACN TO PAY</h2>
            <img src={iaaconQrCode} alt="IAACON payment QR code" />
          </section>
          <div className="payment-complete-action payment-complete-action-mobile">
            <button
              className="payment-complete-button"
              type="button"
              onClick={() => {
                setSubmissionState({ status: "idle", message: "" });
                setPaymentModalOpen(true);
              }}
            >
              Complete Your Payment
            </button>
          </div>
          <section
            className="bank-details"
            aria-labelledby="bank-details-title"
          >
            <h1 id="bank-details-title">BANK DETAILS</h1>
            <dl className="bank-details-table">
              <div className="bank-details-row">
                <dt>Account Name:</dt>
                <dd>IAACON 2026</dd>
              </div>
              <div className="bank-details-row">
                <dt>Bank Name:</dt>
                <dd>HDFC BANK LTD</dd>
              </div>
              <div className="bank-details-row">
                <dt>Branch:</dt>
                <dd>Bodakdev Drive in Theatre</dd>
              </div>
              <div className="bank-details-row">
                <dt>Account Number:</dt>
                <dd>50200117913078</dd>
              </div>
              <div className="bank-details-row">
                <dt>IFSC Code:</dt>
                <dd>HDFC0000049</dd>
              </div>
            </dl>
          </section>
          {/* <div className="payment-complete-action payment-complete-action-mobile">
            <button
              className="payment-complete-button"
              type="button"
              onClick={() => {
                setSubmissionState({ status: "idle", message: "" });
                setPaymentModalOpen(true);
              }}
            >
              Complete Your Payment
            </button>
          </div> */}
        </main>
        <div className="payment-complete-action payment-complete-action-desktop">
          <button
            className="payment-complete-button"
            type="button"
            onClick={() => {
              setSubmissionState({ status: "idle", message: "" });
              setPaymentModalOpen(true);
            }}
          >
            Complete Your Payment
          </button>
        </div>
        {paymentModalOpen && (
          <div className="payment-modal-backdrop">
            <section
              className="payment-modal"
              role="dialog"
              aria-modal="true"
              aria-labelledby="payment-modal-title"
            >
              {/* <button
                className="payment-modal-close"
                type="button"
                aria-label="Close payment instructions"
                onClick={() => setPaymentModalOpen(false)}
              >
                &times;
              </button> */}
              <h2 id="payment-modal-title">Complete Your Payment</h2>

              <form onSubmit={handleTransactionSubmit}>
                <label htmlFor="transaction-id">
                  Transaction ID <span>*</span>
                </label>
                <input
                  id="transaction-id"
                  name="transactionId"
                  type="text"
                  autoComplete="off"
                  value={transactionId}
                  onChange={(event) => setTransactionId(event.target.value)}
                  required
                  disabled={
                    submissionState.status === "submitting" ||
                    submissionState.status === "success"
                  }
                />
                {submissionState.message && (
                  <p
                    className={`payment-submission-message ${submissionState.status}`}
                    role="status"
                  >
                    {submissionState.message}
                  </p>
                )}
                <button
                  className="payment-submit-button"
                  type="submit"
                  disabled={
                    submissionState.status === "submitting" ||
                    submissionState.status === "success"
                  }
                >
                  {submissionState.status === "submitting"
                    ? "Submitting..."
                    : "Submit Payment Information"}
                </button>
                {submissionState.status === "success" && (
                  <button
                    className="payment-submit-button"
                    type="button"
                    onClick={() => {
                      window.location.href =
                        "https://surgicshare.com/live-conference-workshop";
                    }}
                  >
                    Redirect To Live Conference
                  </button>
                )}
              </form>
            </section>
          </div>
        )}
      </>
    );
  }

  return (
    <div className="loader-container">
      <h4>Un Authorized User</h4>
      <button className="orange-btn" onClick={redirectBack}>
        Go to Site
      </button>
    </div>
  );
};

export default Dashboard;
